import { toFlagId } from '@atlassian/jira-flags'; // ignore-for-ENGHEALTH-17759

export const PERMISSION_ERROR_FLAG_ID = toFlagId('permission-error-flag');
export const ERROR_FLAG_ID = toFlagId('error-flag');

export const ISSUE_COUNT = 'ISSUE_COUNT' as const;
export const ORIGINAL_ESTIMATE = 'ORIGINAL_ESTIMATE' as const;
export const STORY_POINTS = 'STORY_POINTS' as const;

export const APP_IDENTIFIER = 'backlog-split-issue';
export const PACKAGE_NAME = 'jira-software-backlog-split-issue';
export const SOURCE_NAME = 'SplitIssue';

export const MUTATION_FAILURE = 'mutation failed';

export const EXPERIENCES = {
	viewApp: 'viewSplitIssueModal',
	saveApp: 'saveSplitIssue',
} as const;

export const SUMMARY_CHAR_LIMIT = 255;

export const SPLIT_ISSUE_INPUT = 'split-issue-modal.summary.split-issue-input';
